/* eslint-disable no-restricted-syntax */
import { addListener } from '@chat/utils';
import { useEffect, useRef, useState } from 'react';
import useObjectState from './useObjectState';

const eMap = {
    hidden: 'visibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange',
    mozHidden: 'mozvisibilitychange'
};
interface IReturn {
    start: () => void;
    stop: () => void;
}
function useFlicker({ prefix = [], sound }: { prefix: Array<string>; sound: any }): IReturn {
    const timer = useRef(null);
    const [loaded, setLoaded] = useState(0);
    const [audio, setAudio] = useState(null);
    const [seed, setSeed] = useState(0);
    const [name, setName] = useState(null);
    // const [ename, setEname] = useState(null);
    const [doc] = useState(document);
    const { objState: title, handleObjState: setTitle } = useObjectState({
        initialValue: {
            pre_title: '',
            last_title: ''
        }
    });

    // 不同浏览器内核隐藏的判断不同
    useEffect(() => {
        setTitle('pre_title', doc.title);
        for (const key in eMap) {
            if (key in doc) {
                setName(key);
                // setEname(eMap[key]);
                return;
            }
        }
    }, []);
    // 标签是否隐藏
    const _hidden = () => {
        return doc[name] || false;
    };
    // 获取当前title
    const _title = (t) => {
        if (!t) {
            return doc.title;
        }
        if (t !== title.last_title) {
            setTitle('last_title', t);
            doc.title = t;
        }
    };
    useEffect(() => {
        setLoaded(0);
        let _audio;
        if (sound) {
            try {
                if (typeof Audio === 'undefined') {
                    // @ts-ignore
                    _audio = new Audio(sound);
                } else {
                    _audio = document.createElement('audio');
                    _audio.src = sound;
                }
                addListener(_audio, 'canplaythrough', function () {
                    setLoaded(1);
                    _audio.pause();
                });
                setAudio(_audio);
            } catch (e) {}
        }
    }, []);
    // 播放提示音
    const play = () => {
        if (loaded) {
            try {
                audio.play();
            } catch (e) {}
        }
    };
    // 停止改变
    const stop = () => {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
        }
        _title(title.pre_title);
        setSeed(0);
    };
    // 标题改变
    const _change = () => {
        const _focus = !_hidden();
        const len = prefix.length;
        const index = (seed + 1) % len;
        if (_focus) {
            return stop();
        }
        if (seed === 0) {
            play();
        }
        setSeed(seed + 1);
        _title(prefix[index] + title.pre_title);
    };
    useEffect(() => {
        if (seed > 0) {
            clearTimeout(timer.current);
            timer.current = setTimeout(_change, 500);
        }
    }, [seed]);
    // 启动
    const start = () => {
        const _focus = !_hidden();
        if (_focus || seed > 0) {
            return;
        }
        _change();
    };
    return {
        stop,
        start
    };
}

export default useFlicker;
